import { Box, RgMatchedFace } from '@hakimo-ui/hakimo/types';
import { useMemo } from 'react';
import { toFaceBoxes, toOverlayFaces } from './util';

export interface MatchedFaceLayersOptions {
  matchedFaces: RgMatchedFace[] | undefined;
  cameraName?: string;
  videoStartTime?: string;
  alarmType?: string;
  baseBoxes?: Box[];
}

export function useMatchedFaceLayers({
  matchedFaces,
  cameraName,
  videoStartTime,
  alarmType,
  baseBoxes,
}: MatchedFaceLayersOptions) {
  const overlayFaces = useMemo(
    () =>
      toOverlayFaces(matchedFaces, { cameraName, videoStartTime, alarmType }),
    [matchedFaces, cameraName, videoStartTime, alarmType]
  );
  const boxes = useMemo(
    () => [...(baseBoxes ?? []), ...toFaceBoxes(matchedFaces)],
    [baseBoxes, matchedFaces]
  );
  return { overlayFaces, boxes };
}
